import { TranslateService } from '@ngx-translate/core';
import { take, map } from 'rxjs/operators';
import { of, Observable } from 'rxjs';

export class SubscriberType {

    arr: any[];

    private translateInit = 'envelope.signatory.subscriberType.';

    constructor(private translate: TranslateService) {
    }

    public Init(): Observable<any> {
        return this.translate.get([this.translateInit.concat('signatory'),this.translateInit.concat('witness')]).pipe(
            take(1),
            map(x=> {
                this.arr = [
                    { id: 0, value: x[this.translateInit.concat('signatory')]},
                    { id: 1, value: x[this.translateInit.concat('witness')]}
                ];
                return of();
            })
        );
    }

    public List(): Array<any> {
        return this.arr;
    }

    public Get(id) {
        return this.arr[id];
    }

    public GetValue(id): string {
        switch (id) {
            case 0:
                return this.translateInit.concat('signatory');
                break;
            case 1:
                return this.translateInit.concat('witness');
                break;
        }
    }
}
